import { useTranslation } from 'react-i18next'
import React, { Fragment, useState } from 'react'

import { useAssetActions } from '../../_actions/assetActions'
import Link from '../../../../components/actions/Link'
import ModalMenu from '../../../../components/navigation/ModalMenu'
import AssetCard from './AssetCard'

const AssetListItem = ({ item }) => {
  const { t } = useTranslation()
  const [actionsOpen, setActionsOpen] = useState(false)
  const [options] = useAssetActions(item)

  return (
    <Fragment>
      <Link block onClick={() => setActionsOpen(true)}>
        <AssetCard item={item} />
      </Link>
      <ModalMenu t={t} open={actionsOpen} onClose={() => setActionsOpen(false)} options={options} />
    </Fragment>
  )
}

export default AssetListItem
